import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';

/**
 * @export CampaignConfigModel
 * @export CampaignConfigBuilder
 * @export RedeemConfigModel
 * @export RedeemConfigBuilder
 * @export RedeemShippingAdressModel
 * @export RedeemShippingAdressBuilder
 * @export RedeemInfoConfigModel
 * @export RedeemInfoConfigBuilder
 * @export RedeemLocationConfigModel
 * @export RedeemOtherConfigModel
 * @export RedeemOtherConfigBuilder
 * @export CampaignListConfigModel
 * @export CampaignListConfigBuilder
 * @export CampaignListFilterConfigModel
 * @export CampaignListFilterConfigBuilder
 */

//#region Campaign
export function CampaignConfigModel(strId, strType, isWithRelate, strRelateConfig, numRelateTop, strSponsorId, strRedeemMedia, strWalletCard) {
    this.strId = strId || null;
    this.strLocale = Locale.getLocaleCode();
    this.strType = strType || null;
    this.isWithRelate = isWithRelate || false;
    this.strRelateConfig = strRelateConfig || null;
    this.numRelateTop = numRelateTop || 0;
    this.strSponsorId = strSponsorId || null;
    this.strRedeemMedia = strRedeemMedia || null;
    this.strWalletCard = strWalletCard || null;

    this.updateListConfig = function (objCampaignConfig) {
        this.strId = objCampaignConfig.strId;
        this.strLocale = objCampaignConfig.strLocale;
        this.strType = objCampaignConfig.strType;
        this.isWithRelate = objCampaignConfig.isWithRelate;
        this.strRelateConfig = objCampaignConfig.strRelateConfig;
        this.numRelateTop = objCampaignConfig.numRelateTop;
        this.strSponsorId = objCampaignConfig.strSponsorId;
        this.strRedeemMedia = objCampaignConfig.strRedeemMedia;
        this.strWalletCard = objCampaignConfig.strWalletCard;
    };

    this.getParams = function() {
        var params = {
            type: this.strType,
            locale: this.strLocale,
            with_relate: this.isWithRelate,
            relate_config: this.strRelateConfig,
            relate_top: this.numRelateTop,
            sponsorId: this.strSponsorId,
            redeem_media: this.strRedeemMedia,
            // walletcard: this.strWalletCard,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params
    };
}
export function CampaignConfigBuilder() {
    this.campaignConfig = new CampaignConfigModel();

    this.create = () => {
        return this.campaignConfig;
    };

    this.setCampaignId = (strId) => {
        this.campaignConfig.strId = strId;
        return this;
    };

    this.setLocale = () => {
        this.campaignConfig.strLocale = Locale.getLocaleCode();
        return this;
    };

    this.setType = (strType) => {
        this.campaignConfig.strType = strType;
        return this;
    };

    this.setWithRelate = (isWithRelate) => {
        this.campaignConfig.isWithRelate = isWithRelate;
        return this;
    };

    this.setRelateConfig = (strRelateConfig) => {
        this.campaignConfig.strRelateConfig = strRelateConfig;
        return this;
    };

    this.setRelateTop = (numRelateTop) => {
        this.campaignConfig.numRelateTop = numRelateTop;
        return this;
    };

    this.setSponsorId = (strSponsorId) => {
        this.campaignConfig.strSponsorId = strSponsorId;
        return this;
    };

    this.setRedeemMedia = (strRedeemMedia) => {
        this.campaignConfig.strRedeemMedia = strRedeemMedia;
        return this;
    };

    this.setWalletCard = (strWalletCard) => {
        this.campaignConfig.strWalletCard = strWalletCard;
        return this;
    };
}
//#endregion Campaign
//#region Redeem
export function RedeemConfigModel() {
    this.campaignId = '';
    this.availablePoint = 0;
    this.redeemMedia = '';
    this.walletCard = '';
}

export function RedeemConfigBuilder() {
    this.redeemConfig = new RedeemConfigModel();

    this.create = () => {
        return this.redeemConfig;
    };

    this.setCampaignId = (campaignId) => {
        this.redeemConfig.campaignId = campaignId;
        return this;
    };

    this.setAvailablePoint = (availablePoint) => {
        this.redeemConfig.availablePoint = availablePoint;
        return this;
    };

    this.setRedeemMedia = (redeemMedia) => {
        this.redeemConfig.redeemMedia = redeemMedia;
        return this;
    };

    this.setWalletCard = (walletCard) => {
        this.redeemConfig.walletCard = walletCard;
        this.redeemConfig.redeemMedia = 'stamp';
        return this;
    };
}

export function RedeemShippingAdressModel() {
    this.shippingFirstName = '';
    this.shippingLastName = '';
    this.firstName = '';
    this.lastName = '';
    this.address = '';
    this.zipcode = '';
    this.contactNumber = '';
    this.email = '';
    this.addressKey = '';
}

export function RedeemShippingAdressBuilder() {
    this.redeemShippingAddress = new RedeemShippingAdressModel();

    this.create = () => {
        return this.redeemShippingAddress;
    };

    this.initialWithProfileAddress = (profile, profileAddress) => {
        if(!profile || !profileAddress) return this;

        this.redeemShippingAddress.shippingFirstName = profile.strFirstName || '';
        this.redeemShippingAddress.shippingLastName = profile.strLastName || '';
        this.redeemShippingAddress.contactNumber = profile.strContactNumber || '';
        this.redeemShippingAddress.email = profile.strEmail || '';
        this.redeemShippingAddress.address = profileAddress.strFullAddress || '';
        this.redeemShippingAddress.zipcode = profileAddress.strZipcode || '';

        return this;
    };

    this.initialWithProfileShippingAddress = (profileShippingAddress) => {
        if(!profileShippingAddress) return this;

        this.redeemShippingAddress.shippingFirstName = profileShippingAddress.strFirstName || '';
        this.redeemShippingAddress.shippingLastName = profileShippingAddress.strLastName || '';
        this.redeemShippingAddress.contactNumber = profileShippingAddress.strContactNumber || '';
        this.redeemShippingAddress.email = profileShippingAddress.strEmail || '';
        this.redeemShippingAddress.address = profileShippingAddress.strAddress || '';
        this.redeemShippingAddress.zipcode = profileShippingAddress.strZipcode || '';
        this.redeemShippingAddress.addressKey = profileShippingAddress.strAddressKey || '';

        return this;
    };
}

export function RedeemInfoConfigModel() {
    this.info1 = '';
    this.info2 = '';
    this.info3 = '';
    this.info4 = '';
    this.info5 = '';
}

export function RedeemInfoConfigBuilder() {
    this.redeemInfoConfig = new RedeemInfoConfigModel()

    this.create = () => {
        return this.redeemInfoConfig;
    };

    this.setInfo1 = (info1) => {
        this.redeemInfoConfig.info1 = info1;
        return this;
    };

    this.setInfo2 = (info2) => {
        this.redeemInfoConfig.info2 = info2;
        return this;
    };

    this.setInfo3 = (info3) => {
        this.redeemInfoConfig.info3 = info3;
        return this;
    };

    this.setInfo4 = (info4) => {
        this.redeemInfoConfig.info4 = info4;
        return this;
    };

    this.setInfo5 = (info5) => {
        this.redeemInfoConfig.info5 = info5;
        return this;
    };
}

export function RedeemLocationConfigModel() {
    this.locationId = '';
    this.center = '';
    this.latitude = '';
    this.longitude = '';
}

export function RedeemLocationConfigBuilder() {
    this.redeemLocationConfig = new RedeemLocationConfigModel();

    this.create = () => {
        return this.redeemLocationConfig;
    };

    this.setLocationId = (locationId) => {
        this.redeemLocationConfig.locationId = locationId;
        return this;
    };

    this.setLocationId = (center) => {
        this.redeemLocationConfig.center = center;
        return this;
    };

    this.setLocationId = (latitude) => {
        this.redeemLocationConfig.latitude = latitude;
        return this;
    };

    this.setLocationId = (longitude) => {
        this.redeemLocationConfig.longitude = longitude;
        return this;
    };
}

export function RedeemOtherConfigModel() {
    this.isCache = true;
    this.redeemBy = '';
    this.tranId = '';
    this.reservationjson = '';
    this.promoCode = '';
    this.spBaht = '';
    this.spPoints = '';
    this.giftTo = '';
}

export function RedeemOtherConfigBuilder() {
    this.redeemOtherConfig = new RedeemOtherConfigModel();

    this.create = () => {
        return this.redeemOtherConfig;
    };

    this.setIsCache = (isCache) => {
        this.redeemOtherConfig.isCache = isCache;
        return this;
    };

    this.setRedeemBy = (redeemBy) => {
        this.redeemOtherConfig.redeemBy = redeemBy;
        return this;
    };

    this.setTranId = (tranId) => {
        this.redeemOtherConfig.tranId = tranId;
        return this;
    };

    this.setReservationjson = (reservationjson) => {
        this.redeemOtherConfig.reservationjson = reservationjson;
        return this;
    };

    this.setPromoCode = (promoCode) => {
        this.redeemOtherConfig.promoCode = promoCode;
        return this;
    };

    this.setSpBaht = (spBaht) => {
        this.redeemOtherConfig.spBaht = spBaht;
        return this;
    };

    this.setSpPoints = (spPoints) => {
        this.redeemOtherConfig.spPoints = spPoints;
        return this;
    };

    this.setGiftTo = (giftTo) => {
        this.redeemOtherConfig.giftTo = giftTo;
        return this;
    };
}
//#endregion Redeem
//#region List
export function CampaignListConfigModel(strConfigList, intTop, strCatId, intSkip, strTags, strType, strMode, strSearch, strCampaignImageSize) {
    this.isSeeMoreEnable = true;
    this.strConfigList = strConfigList || '';
    this.intSkip = intSkip || 0;
    this.defaultTopAmount = intTop || 25;
    this.strCatId = strCatId || '';
    this.strTags = strTags || '';
    this.strLocale = Locale.getLocaleCode();
    this.strType = strType || '';
    this.strMode = strMode || '';
    this.strSearch = strSearch || '';
    this.strCampaignImageSize = strCampaignImageSize || 'large';

    this.updateListConfig = function (campaignListConfig) {
        this.isSeeMoreEnable = campaignListConfig.isSeeMoreEnable;
        this.strConfigList = campaignListConfig.strConfigList;
        this.intSkip = campaignListConfig.intSkip;
        this.defaultTopAmount = campaignListConfig.defaultTopAmount;
        this.strCatId = campaignListConfig.strCatId;
        this.strTags = campaignListConfig.strTags;
        this.strLocale = Locale.getLocaleCode();
        this.strType = campaignListConfig.strType;
        this.strMode = campaignListConfig.strMode;
        this.strCampaignImageSize = campaignListConfig.strCampaignImageSize;
    };

    this.resetListConfig = function () {
        this.isSeeMoreEnable = true;
        this.intSkip = 0;
        this.strLocale = Locale.getLocaleCode();
    };

    this.getParams = function() {
        var params = {
            byConfig: "true",
            config: this.strConfigList,
            top: this.defaultTopAmount,
            skip: this.intSkip,
            tags: this.strTags,
            cat: this.strCatId,
            locale: this.strLocale,
            type: this.strType,
            mode: this.strMode,
            q: this.strSearch,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}

export function CampaignListConfigBuilder() {
    this.campaignListConfig = new CampaignListConfigModel();

    this.create = () => {
        return this.campaignListConfig;
    };

    this.setSeeMore = (isSeeMoreEnable) => {
        this.campaignListConfig.isSeeMoreEnable = isSeeMoreEnable;
        return this;
    };

    this.setCampaignImageSize = (strImageSize) => {
        this.campaignListConfig.strCampaignImageSize = strImageSize;
        return this;
    };

    this.setCatId = (strCatId) => {
        this.campaignListConfig.strCatId = strCatId;
        return this;
    };

    this.setConfigList = (strConfig) => {
        this.campaignListConfig.strConfigList = strConfig;
        return this;
    };

    this.setLocale = () => {
        this.campaignListConfig.strLocale = Locale.getLocaleCode();
        return this;
    };

    this.setMode = (strMode) => {
        this.campaignListConfig.strMode = strMode;
        return this;
    };

    this.setSearch = (strSearch) => {
        this.campaignListConfig.strSearch = strSearch;
        return this;
    };

    this.addSkip = () => {
        this.campaignListConfig.intSkip += this.campaignListConfig.defaultTopAmount;
        return this;
    };

    this.setSkip = (intSkip) => {
        this.campaignListConfig.intSkip = intSkip;
        return this;
    };

    this.setTags = (strTags) => {
        this.campaignListConfig.strTags = strTags;
        return this;
    };

    this.setType = (strType) => {
        this.campaignListConfig.strType = strType;
        return this;
    };

    this.setTop = (intTop) => {
        this.campaignListConfig.defaultTopAmount = intTop;
        return this;
    };
}

export function CampaignListFilterConfigModel(strSearch, strStartDate, strNearby, strLocation, strLocationAgencyId, intMinPoint, intMaxPoint, intMinPrice, intMaxPrice, intMinRating, intMaxRating) {
    this.strSearch = strSearch || '';
    this.strNearby = strNearby || '';
    this.strStartDate = strStartDate || '';
    this.intMinPoint = intMinPoint || 0;
    this.intMaxPoint = intMaxPoint || 0;
    this.intMinPrice = intMinPrice || 0;
    this.intMaxPrice = intMaxPrice || 0;
    this.intMinRating = intMinRating || 0;
    this.intMaxRating = intMaxRating || 0;
    this.strLocation = strLocation || '';
    this.strLocationAgencyId = strLocationAgencyId || '';

    this.updateFilterListConfig = function (objCampaignListFilterConfig) {
        this.strSearch = objCampaignListFilterConfig.strSearch;
        this.strNearby = objCampaignListFilterConfig.strNearby;
        this.strStartDate = objCampaignListFilterConfig.strStartDate;
        this.intMinPoint = objCampaignListFilterConfig.intMinPoint;
        this.intMaxPoint = objCampaignListFilterConfig.intMaxPoint;
        this.intMinPrice = objCampaignListFilterConfig.intMinPrice;
        this.intMaxPrice = objCampaignListFilterConfig.intMaxPrice;
        this.intMinRating = objCampaignListFilterConfig.intMinRating;
        this.intMaxRating = objCampaignListFilterConfig.intMaxRating;
        this.strLocation = objCampaignListFilterConfig.strLocation;
        this.strLocationAgencyId = objCampaignListFilterConfig.strLocationAgencyId;
    };

    this.getParams = function() {
        var params = {
            q: this.strSearch,
            startdate: this.strStartDate,
            center: this.strNearby,
            location: this.strLocation,
            locationAgencyId: this.strLocationAgencyId,
            minpoints: this.intMinPoint,
            maxpoints: this.intMaxPoint,
            minprice: this.intMinPrice,
            maxprice: this.intMaxPrice,
            minrating: this.intMinRating,
            maxrating: this.intMaxRating,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}

export function CampaignListFilterConfigBuilder() {
    this.campaignListFilterConfig = new CampaignListFilterConfigModel();

    this.create = () => {
        return this.campaignListFilterConfig;
    };

    this.setLocation = (strLocation) => {
        this.campaignListFilterConfig.strLocation = strLocation;
        return this;
    };

    this.setLocationAgency = (strLocationAgencyId) => {
        this.campaignListFilterConfig.strLocationAgencyId = strLocationAgencyId;
        return this;
    };

    this.setMinPoint = (intMinPoint) => {
        this.campaignListFilterConfig.intMinPoint = intMinPoint;
        return this;
    };

    this.setMaxPoint = (intMaxPoint) => {
        this.campaignListFilterConfig.intMaxPoint = intMaxPoint;
        return this;
    };

    this.setMinPrice = (intMinPrice) => {
        this.campaignListFilterConfig.intMinPrice = intMinPrice;
        return this;
    };

    this.setMaxPrice = (intMaxPrice) => {
        this.campaignListFilterConfig.intMaxPrice = intMaxPrice;
        return this;
    };

    this.setMinRating = (intMinRating) => {
        this.campaignListFilterConfig.intMinRating = intMinRating;
        return this;
    };

    this.setMaxRating = (intMaxRating) => {
        this.campaignListFilterConfig.intMaxRating = intMaxRating;
        return this;
    };

    this.strNearby = (strNearby) => {
        this.campaignListFilterConfig.strNearby = strNearby;
        return this;
    };

    this.setSearch = (strSearch) => {
        this.campaignListFilterConfig.strSearch = strSearch;
        return this;
    };

    this.setStartDate = (strStartDate) => {
        this.campaignListFilterConfig.strStartDate = strStartDate;
        return this;
    }
}
//#endregion List
